import moment from 'moment';
import { useState } from 'react';

import { TableCompHead } from '../../../../../../components/ui';
import formatDate from '../../../../../../components/common/formatDate';
import DatePickerMui from '../../../../../../components/common/DatePickerMui';
import { TableInput } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
  customer: any;
}

const heading = [
  'S. No.',
  'Check Points',
  'C (5)',
  'O (2)',
  'NC (0)',
  'Actual Observation',
];
const heading2 = [
  'Before',
  'After',
  'Repair',
  'Replace',
  'Remarks',
  'Before',
  'After',
  'Repair',
  'Replace',
  'Remarks',
];
const THead = ({ moduleData, isView, customer }: IProps) => {
  const [render, setRender] = useState(false);
  const part_no = useQuery('part_no');
  const part_name = useQuery('part_name');
  const machin_no = useQuery('machin_no');

  return (
    <thead>
      <TableCompHead
        colSpan={6}
        rowSpan={3}
        labels={['Doc. No.: ', 'Rev. No.:', 'Eff. Date:']}
        values={['RM-QAS-A-007', '00', '01-04-2023']}
        heading="Process Audit Check Sheet "
      />
      <tr>
        <th>Part Name : {part_name}</th>
        <th>Part No. : {part_no}</th>
        <th colSpan={4} align="left">
          Audit Date :{' '}
          {isView ? (
            formatDate(moduleData.d1)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.d1)}
              onChange={(date) => {
                moduleData.d1 = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>

      <tr>
        {heading.map((header) => (
          <th
            key={header}
            colSpan={
              (header === 'Observation' && 2) ||
              (header === 'Action Taken' && 3) ||
              1
            }
            rowSpan={
              header === 'Observation' || header === 'Action Taken' ? 1 : 2
            }
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
